import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../app/core/common/common.service';
import { ProductOption, SubmissionStartType } from '../../types/program-types';
import { SubmissionStartChoiceComponent } from '../../submission-start-choice.component';

@Component({
  selector: 'app-guardian-elite',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './guardian-elite.component.html',
  styleUrl: './guardian-elite.component.scss'
})
export class GuardianEliteComponent {

  @Input() public selectedProduct: ProductOption | null = null;

  public selected: SubmissionStartType | null = null;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly commonService: CommonService,
    private readonly modalService: NgbModal
  ) { }

  public select(option: SubmissionStartType): void {
    this.selected = option;
  }

  public continue(): void {
    if (!this.selected) {
      return;
    }

    this.commonService.setSkipDirtyGuard(true);

    this.commonService.clearIdsFromSession(); 
      if (this.selected === 'scratch') {
        this.commonService.navigateToURLWithtenantCode('submission');
      }
      if (this.selected === 'upload') {
        this.commonService.navigateToURLWithtenantCode('submission/upload');
      }

    // Resolve the modal with the chosen route so SubmissionStartChoiceComponent
    // can relay it to whoever opened the flow in the first place.
    this.activeModal.close(this.selected);
  }

  public back(): void {
    this.activeModal.dismiss();
    this.openSubmissionStartChoice();
  }

  private openSubmissionStartChoice(): void {
        this.modalService.open(SubmissionStartChoiceComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl',
          keyboard: false,
        });
  }
}
